import React, { Component } from 'react';
import GridLayout from './GridLayout'

class GraphLayout extends Component {
  render() {
      return <GridLayout { ...this.props }/>
  }
}
export default GraphLayout